import React from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, AlertTitle } from '@mui/material';
import { getErrorMessage } from '@/api/client';

interface ErrorAlertProps {
  error: Error | unknown;
  title?: string;
}

const ErrorAlert: React.FC<ErrorAlertProps> = ({ error, title }) => {
  const { t } = useTranslation('components');
  const message = getErrorMessage(error);

  return (
    <Alert severity="error" sx={{ mb: 2 }}>
      <AlertTitle>{title || t('errorAlert.defaultTitle')}</AlertTitle>
      {message}
    </Alert>
  );
};


export default ErrorAlert;
